import { Expose } from "class-transformer";
import { CompanyProfileBase } from "domain/model/base";

export default class CompanyProfile extends CompanyProfileBase {
  @Expose({name: "prefecture"})
  prefecture?: string;
};
